import { Outlet, useLocation } from 'react-router-dom'

import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import PageErrorBoundary from '~/components/pageErrorBoundary'
import usePrivateRoutesRedirect from '~/hooks/usePrivateRoutesRedirect'
import ContentWrapper from '~/layouts/account/contentWrapper'
import { EAdminPortalClientPath } from '~/models/api'
import { ECognitoGroups } from '~/models/auth'

function AdminRestrictedLayout() {
  const { pathname } = useLocation()
  const requiredUserGroups = [ECognitoGroups.admin]
  const isAuthCheckComplete = usePrivateRoutesRedirect({ requiredUserGroups })

  if (!isAuthCheckComplete) {
    return <LoadingWithBackdrop show />
  }

  const staticRoutesWithoutPadding = [
    EAdminPortalClientPath.campaignTemplates,
    EAdminPortalClientPath.orgsAndUsers,
    EAdminPortalClientPath.promptMetadata,
    EAdminPortalClientPath.voiceTemplates,
  ]

  let noPadding = false

  if (staticRoutesWithoutPadding.some((path) => pathname.includes(path))) {
    noPadding = true
  }

  return (
    <ContentWrapper
      showContactInfoButton={false}
      fullWidth
      noPadding={noPadding}
    >
      <PageErrorBoundary>
        <Outlet />
      </PageErrorBoundary>
    </ContentWrapper>
  )
}

export default AdminRestrictedLayout
